export default "/images/vendor/flag-icon-css/flags/4x3/uz.svg?a4de118b4064c4b8dd549fa826cca702";